/* ============================================================
   KD PDP Polish JS v12(2026-05-09)
   - 文字 fade-in-up:用 element.style.setProperty + !important inline
     绕过所有 CSS class 优先级冲突(.kd-lenis-h2.in / kdProductTitleAppleScroll 等)
   - 自动补全 PDP 内 img 的 alt(无障碍 / SEO)
   - IO threshold 0.15,stagger 80ms
   ============================================================ */
(function () {
  'use strict';
  if (!document.body.classList.contains('template-product')) return;

  var __kdInited = false;

  var SECTIONS = [
    'image_with_text_74CitP',
    'image_with_text_7xnDna',
    'custom_content_4VxBmR',
    'custom_content_pnmz4J',
    'custom_content_p389AW',
    'custom_content_Bnn4ep',
    'custom_content_YtH4w6',
    'custom_content_jHQQhj'
  ];

  var TEXT_SELECTORS = [
    '.m-richtext__subtitle',
    '.m-content-box__subheading',
    '.m-richtext__title',
    '.m-content-box__heading',
    '.m-richtext__description',
    '.m-richtext__button'
  ].join(',');

  var EASE = 'cubic-bezier(0.16, 1, 0.3, 1)';
  var DURATION = '0.9s';

  function setHidden(el) {
    // inline + !important + animation:none 是最高优先级,赢过 .kd-lenis-* / KD scroll-driven
    el.style.setProperty('opacity', '0', 'important');
    el.style.setProperty('transform', 'translateY(28px)', 'important');
    el.style.setProperty('transition',
      'opacity ' + DURATION + ' ' + EASE + ', transform ' + DURATION + ' ' + EASE,
      'important');
    el.style.setProperty('animation', 'none', 'important');
    el.style.setProperty('animation-timeline', 'none', 'important');
    el.style.setProperty('will-change', 'opacity, transform');
    el.classList.add('kd-pdp-fx-target');
  }

  function setVisible(el) {
    el.style.setProperty('opacity', '1', 'important');
    el.style.setProperty('transform', 'translateY(0)', 'important');
    el.classList.add('kd-pdp-fx-in');
  }

  function initFadeIn() {
    SECTIONS.forEach(function (secId) {
      var sec = document.querySelector('[id*="' + secId + '"]');
      if (!sec) return;

      var targets = Array.prototype.slice.call(sec.querySelectorAll(TEXT_SELECTORS));
      if (!targets.length) return;
      targets.forEach(setHidden);

      if (!('IntersectionObserver' in window)) {
        targets.forEach(setVisible);
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          targets.forEach(function (el, i) {
            setTimeout(function () { setVisible(el); }, 80 * i);
          });
          io.unobserve(en.target);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

      io.observe(sec);
    });
  }

  // === 图片 alt 自动补全(无障碍 / SEO)===
  function fillAltText() {
    var productTitle = '';
    var titleEl = document.querySelector('.m-product__title, .product__title, h1[class*="product"]');
    if (titleEl) productTitle = titleEl.textContent.trim().slice(0, 80);
    if (!productTitle) productTitle = 'Kickdopa Energy Pouches';

    var skipPatterns = /logo|icon|chevron|arrow|cart|search|menu|close/i;
    var imgs = document.querySelectorAll('img');
    var added = 0;
    imgs.forEach(function (img) {
      if (img.hasAttribute('alt') && img.alt) return;
      var ctx = ((img.parentNode && img.parentNode.className) || '') + ' ' + (img.className || '');
      if (skipPatterns.test(ctx)) {
        if (!img.hasAttribute('alt')) img.alt = '';
        return;
      }
      img.alt = productTitle;
      added++;
    });
    return added;
  }

  function init() {
    if (__kdInited) return;
    __kdInited = true;
    try { initFadeIn(); } catch (e) {}
    try { fillAltText(); } catch (e) {}
    setTimeout(function () { try { fillAltText(); } catch (e) {} }, 1500);
    setTimeout(function () { try { fillAltText(); } catch (e) {} }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () {
    __kdInited = false;
    init();
  });
})();
